import React from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { Sparkles, Calendar } from 'lucide-react';

const WhatsNew = () => {
  const updates = [
    {
      version: '2.4.0',
      date: 'Septembre 2026',
      items: [
        '🟣 Analyses de sang : présentation plus claire et descriptive',
        '🟣 Chat santé plus fluide qui suit le fil de la conversation',
        '🟣 Sources médicales officielles (HAS, Assurance Maladie, OMS, ANSM)',
        '🟣 Informations de sécurité renforcées',
        '🟣 Améliorations de la confidentialité et de la sécurité',
      ],
    },
{
  version: '2.3.0',
  date: 'Avril 2026',
  items: [
    '🟠 Nouvelle fonctionnalité : Carnet de santé',
    '🟠 Refonte de la fonctionnalité : Alertes',
    '🟠 Connexion base de données médicaments BDPM officielle',
  ],
},

    {
      version: '2.2.0',
      date: 'Mars 2026',
      items: [
        '🟡 Nouvelle fonctionnalité : Analyse de sang',
        '🟡 Nouvelle fonctionnalité : Pharmacie',
        "🟡 Refonte de l'interface de l'historique du chat IA ",
        "🟡 Création de l'historique de la fonctionnalité Analyse de sang",
        '🟡 Création de la page  FAQ',
      ],
    },
    {
      version: '2.1.0',
      date: 'Mars 2026',
      items: [
        '🟢 Mode sombre amélioré',
        '🟢 Performance optimisée du chat IA',
        "🟢 Optimisation de l'organisation des articles",
        '🟢 Ouverture unique pour les utilisateurs Feedback',
      ],
    },
    {
      version: '2.0.0',
      date: 'Février 2026',
      items: [
        '🔵 Nouveau forum communautaire',
        '🔵 Profils personnalisables avec avatars',
        '🔵 Sécurité renforcée (OAuth Google)',
        '🔵 Abonnement Premium lancé',
      ],
    },
  ];

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center">
            <Sparkles className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Nouveautés</h1>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Découvrez les dernières améliorations
            </p>
          </div>
        </div>

        {/* Updates List */}
        <div className="space-y-4">
          {updates.map((update, idx) => (
            <div
              key={idx}
              className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700 shadow-sm"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="px-3 py-1 bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 rounded-full text-sm font-semibold">
                  v{update.version}
                </span>
                <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                  <Calendar className="w-4 h-4" />
                  {update.date}
                </div>
              </div>

              <ul className="space-y-2">
                {update.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-gray-700 dark:text-gray-300">
                    <span className="mt-1">•</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="bg-blue-50 dark:bg-blue-950/30 rounded-xl p-4 border border-blue-200 dark:border-blue-900">
          <p className="text-sm text-blue-800 dark:text-blue-300">
            💡 <strong>Suggestion :</strong> Nous écoutons vos retours ! Utilisez la page Feedback
            pour proposer des améliorations.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default WhatsNew;
